import type { ReactElement } from 'react';
import { Box, Button, Stack, Text } from '@citibox-panel/ui';

// TODO: i18n
const COPY = {
  cancel: 'Cancelar',
} as const;

export interface ConfirmStepProps {
  title: string;
  lines: readonly string[];
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  pending: boolean;
  // Put on the heading so the hosting dialog can name itself after the step it is showing.
  titleId?: string;
}

// The «Quitar todo» confirmation, as a step inside the assignment dialog rather than a second
// dialog: the person stays in one modal and «Cancelar» returns to the form with every mark intact.
// Focus starts on «Cancelar» so a stray Enter on arrival backs out instead of removing access.
export function ConfirmStep({
  title,
  lines,
  confirmLabel,
  onConfirm,
  onCancel,
  pending,
  titleId,
}: ConfirmStepProps): ReactElement {
  return (
    <Stack spacing={2}>
      <Text component="h2" variant="h6" {...(titleId !== undefined ? { id: titleId } : {})}>
        {title}
      </Text>
      {lines.map((line) => (
        <Text key={line}>{line}</Text>
      ))}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
        <Button color="neutral" sentenceCase autoFocus onClick={onCancel} disabled={pending}>
          {COPY.cancel}
        </Button>
        <Button
          variant="contained"
          color="error"
          sentenceCase
          loading={pending}
          onClick={onConfirm}
        >
          {confirmLabel}
        </Button>
      </Box>
    </Stack>
  );
}
